"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/popover/index.ts
var popover_exports = {};
__export(popover_exports, {
  WithPopover: () => WithPopover_default,
  default: () => Popover_default
});
module.exports = __toCommonJS(popover_exports);
var import_index2 = require("./index.css");

// src/popover/WithPopover.tsx
var import_react3 = require("react");

// src/common/helpers/index.ts
var calculatePositionedElementStyles = ({
  nodePosition,
  positionedElementRef,
  direction,
  tailOffset: tailOffset2,
  tailLength,
  isPositionFixed = false
}) => {
  const styles = {};
  if (nodePosition && positionedElementRef.current && direction !== "none") {
    const rect = nodePosition.getBoundingClientRect();
    const tooltipRect = positionedElementRef.current.getBoundingClientRect();
    const scrollY = isPositionFixed ? 0 : window.scrollY;
    const scrollX = isPositionFixed ? 0 : window.scrollX;
    const textDirection = document.documentElement.dir || "ltr";
    const isLtr = textDirection === "ltr";
    const verticalMiddlePosition = rect.top + scrollY + rect.height / 2 - tooltipRect.height / 2;
    const verticalTopPosition = rect.top + scrollY - tooltipRect.height - tailOffset2 - tailLength;
    const verticalBottomPosition = rect.top + rect.height + scrollY + tailOffset2 + tailLength;
    const horizontalMiddlePosition = rect.left + scrollX + rect.width / 2 - tooltipRect.width / 2;
    const horizontalLeftPosition = rect.left + scrollX - tooltipRect.width - tailOffset2 - tailLength;
    const horizontalRightPosition = rect.right + scrollX + tailOffset2 + tailLength;
    switch (direction) {
      case "onRight":
        styles.top = verticalMiddlePosition;
        styles.left = isLtr ? horizontalRightPosition : horizontalLeftPosition;
        break;
      case "onBottom":
        styles.top = verticalBottomPosition;
        styles.left = horizontalMiddlePosition;
        break;
      case "onLeft":
        styles.top = verticalMiddlePosition;
        styles.left = isLtr ? horizontalLeftPosition : horizontalRightPosition;
        break;
      case "onTop":
      default:
        styles.top = verticalTopPosition;
        styles.left = horizontalMiddlePosition;
        break;
    }
  }
  return styles;
};
var updatePositionedElementStyles = ({
  nodePosition,
  positionedElementRef,
  direction,
  setPositionedElementStyles,
  tailOffset: tailOffset2,
  tailLength,
  isPositionFixed = false
}) => {
  setPositionedElementStyles(
    calculatePositionedElementStyles({
      nodePosition,
      positionedElementRef,
      direction,
      tailOffset: tailOffset2,
      tailLength,
      isPositionFixed
    })
  );
};

// src/popover/Popover.tsx
var import_classnames4 = __toESM(require("classnames"));
var import_react2 = require("react");

// src/closeButton/index.ts
var import_index = require("./index.css");

// src/closeButton/CloseButton.tsx
var import_classnames2 = __toESM(require("classnames"));

// src/fontAwesomeV6Icon/FontAwesomeV6Icon.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime = require("react/jsx-runtime");
var FontAwesomeV6Icon = ({
  iconStyle,
  iconFamily,
  iconName,
  className,
  title,
  animationType,
  ...HTMLAttributes3
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "i",
  {
    "data-testid": "font-awesome-v6-icon",
    className: (0, import_classnames.default)(
      iconFamily && `fa-${iconFamily}`,
      iconStyle && `fa-${iconStyle}`,
      iconName && `fa-${iconName}`,
      // Default icon style is solid, but only when no iconFamily prop is provided
      !iconFamily && !iconStyle && "fa-solid",
      animationType && `fa-${animationType}`,
      className
    ),
    title,
    ...HTMLAttributes3
  }
);
var FontAwesomeV6Icon_default = FontAwesomeV6Icon;

// src/closeButton/closeButton.module.scss
var closeButton_module_default = {
  "closeButton": "closeButton-module__closeButton___Ab4hh",
  "closeButton-dark": "closeButton-module__closeButton-dark___RqPRh",
  "closeButton-light": "closeButton-module__closeButton-light___UBkFK",
  "closeButton-l": "closeButton-module__closeButton-l___Gw8DM",
  "closeButton-m": "closeButton-module__closeButton-m___11tsA",
  "closeButton-s": "closeButton-module__closeButton-s___4zy5d",
  "closeButton-xs": "closeButton-module__closeButton-xs___bjImb"
};

// src/closeButton/CloseButton.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var CloseButton = ({
  onClick,
  size = "m",
  "aria-label": ariaLabel,
  color = "dark",
  id,
  className,
  ...HTMLAttributes3
}) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
  "button",
  {
    type: "button",
    id,
    "aria-label": ariaLabel,
    className: (0, import_classnames2.default)(
      closeButton_module_default.closeButton,
      closeButton_module_default[`closeButton-${color}`],
      closeButton_module_default[`closeButton-${size}`],
      className
    ),
    onClick,
    ...HTMLAttributes3,
    children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FontAwesomeV6Icon_default, { iconName: "close" })
  }
);
var CloseButton_default = CloseButton;

// src/typography/Typography.tsx
var import_classnames3 = __toESM(require("classnames"));
var import_react = require("react");

// ../component-library-styles/typography.module.scss
var typography_module_default = {
  "heading-xxl": "typography-module__heading-xxl___t4Iml",
  "heading-xl": "typography-module__heading-xl___wbMqr",
  "heading-lg": "typography-module__heading-lg___GUMI7",
  "heading-md": "typography-module__heading-md___I661h",
  "heading-sm": "typography-module__heading-sm___2Jm-k",
  "heading-xs": "typography-module__heading-xs___FJljd",
  "body-one": "typography-module__body-one___hKZXX",
  "body-two": "typography-module__body-two___Sa-Eb",
  "body-three": "typography-module__body-three___FIk3k",
  "body-four": "typography-module__body-four___vI1SQ",
  "overline-one": "typography-module__overline-one___rXzIm",
  "overline-two": "typography-module__overline-two___WG6bF",
  "overline-three": "typography-module__overline-three___UK5T-",
  "strong": "typography-module__strong___jtYq4",
  "extra-strong": "typography-module__extra-strong___9SBuV",
  "em": "typography-module__em___2kNMg",
  "figcaption": "typography-module__figcaption___cHscw"
};

// src/typography/Typography.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var Typography = ({
  semanticTag,
  visualAppearance,
  children,
  className,
  style,
  id,
  ...props
}) => {
  const Tag = semanticTag;
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
    Tag,
    {
      id,
      className: (0, import_classnames3.default)(typography_module_default[visualAppearance], className),
      style,
      ...props,
      children
    }
  );
};
var Typography_default = (0, import_react.memo)(Typography);

// src/typography/TypographyElements.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var typographyElementsToGenerate = [
  {
    displayName: "Heading1",
    semanticTag: "h1",
    defaultVisualAppearance: "heading-xxl"
  },
  {
    displayName: "Heading2",
    semanticTag: "h2",
    defaultVisualAppearance: "heading-xl"
  },
  {
    displayName: "Heading3",
    semanticTag: "h3",
    defaultVisualAppearance: "heading-lg"
  },
  {
    displayName: "Heading4",
    semanticTag: "h4",
    defaultVisualAppearance: "heading-md"
  },
  {
    displayName: "Heading5",
    semanticTag: "h5",
    defaultVisualAppearance: "heading-sm"
  },
  {
    displayName: "Heading6",
    semanticTag: "h6",
    defaultVisualAppearance: "heading-xs"
  },
  {
    displayName: "BodyOneText",
    semanticTag: "p",
    defaultVisualAppearance: "body-one"
  },
  {
    displayName: "BodyTwoText",
    semanticTag: "p",
    defaultVisualAppearance: "body-two"
  },
  {
    displayName: "BodyThreeText",
    semanticTag: "p",
    defaultVisualAppearance: "body-three"
  },
  {
    displayName: "BodyFourText",
    semanticTag: "p",
    defaultVisualAppearance: "body-four"
  },
  {
    displayName: "OverlineOneText",
    semanticTag: "p",
    defaultVisualAppearance: "overline-one"
  },
  {
    displayName: "OverlineTwoText",
    semanticTag: "p",
    defaultVisualAppearance: "overline-two"
  },
  {
    displayName: "OverlineThreeText",
    semanticTag: "p",
    defaultVisualAppearance: "overline-three"
  },
  { displayName: "EmText", semanticTag: "em", defaultVisualAppearance: "em" },
  {
    displayName: "StrongText",
    semanticTag: "strong",
    defaultVisualAppearance: "strong"
  },
  {
    displayName: "ExtraStrongText",
    semanticTag: "strong",
    defaultVisualAppearance: "extra-strong"
  },
  {
    displayName: "Figcaption",
    semanticTag: "figcaption",
    defaultVisualAppearance: "figcaption"
  }
];
var generateComponents = (componentsToGenerate) => componentsToGenerate.reduce((acc, componentTemplateData) => {
  const { displayName, semanticTag, defaultVisualAppearance } = componentTemplateData;
  const TypographyElement = (componentProps) => {
    const { visualAppearance, children, className, style, id } = componentProps;
    return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
      Typography_default,
      {
        semanticTag,
        visualAppearance: visualAppearance || defaultVisualAppearance,
        className,
        style,
        id,
        children
      }
    );
  };
  TypographyElement.displayName = displayName;
  return { ...acc, [displayName]: TypographyElement };
}, {});
var {
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  Heading6,
  BodyOneText,
  BodyTwoText,
  BodyThreeText,
  BodyFourText,
  OverlineOneText,
  OverlineTwoText,
  OverlineThreeText,
  EmText,
  StrongText,
  ExtraStrongText,
  Figcaption
} = generateComponents(typographyElementsToGenerate);

// src/popover/popover.module.scss
var popover_module_default = {
  "popover": "popover-module__popover___D1UPQ",
  "informationalSection": "popover-module__informationalSection___hkoow",
  "iconSection": "popover-module__iconSection___Npq7e",
  "contentSection": "popover-module__contentSection___1G-fy",
  "textSection": "popover-module__textSection___2e3ou",
  "buttonsSection": "popover-module__buttonsSection___NUVQO",
  "popover-withImage": "popover-module__popover-withImage___QU4rR",
  "imageSection": "popover-module__imageSection___5frCY",
  "closeButton": "popover-module__closeButton___Upcm-",
  "popover-onTop": "popover-module__popover-onTop___Ho4Ky",
  "popover-onRight": "popover-module__popover-onRight___T2EWm",
  "popover-onBottom": "popover-module__popover-onBottom___KCSsu",
  "popover-onLeft": "popover-module__popover-onLeft___QAJWt",
  "popover-none": "popover-module__popover-none___m6gag",
  "popover-m": "popover-module__popover-m___uinB-"
};

// src/popover/Popover.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var Popover = (0, import_react2.forwardRef)(
  ({
    icon,
    image,
    title,
    content,
    buttons,
    direction = "onTop",
    onClose,
    className,
    size = "m",
    style = {},
    ...HTMLAttributes3
  }, ref) => {
    return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
      "div",
      {
        ref,
        className: (0, import_classnames4.default)(
          popover_module_default.popover,
          image && popover_module_default["popover-withImage"],
          popover_module_default[`popover-${direction}`],
          popover_module_default[`popover-${size}`],
          className
        ),
        style,
        ...HTMLAttributes3,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
            CloseButton_default,
            {
              className: popover_module_default.closeButton,
              onClick: onClose,
              size: "l",
              "aria-label": "Close"
            }
          ),
          image && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: popover_module_default.imageSection, children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("img", { src: image.src, alt: image.alt }) }),
          /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: popover_module_default.informationalSection, children: [
            icon && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: popover_module_default.iconSection, children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { ...icon }) }),
            /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: popover_module_default.contentSection, children: [
              /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: popover_module_default.textSection, children: [
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(Heading5, { children: title }),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(BodyTwoText, { children: content })
              ] }),
              buttons && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: popover_module_default.buttonsSection, children: buttons })
            ] })
          ] })
        ]
      }
    );
  }
);
var Popover_default = Popover;

// src/popover/WithPopover.tsx
var import_jsx_runtime6 = require("react/jsx-runtime");
var tailOffset = 4;
var tailLengths = {
  m: 12
};
var WithPopover = ({
  children,
  showPopover = false,
  popoverProps
}) => {
  const [nodePosition, setNodePosition] = (0, import_react3.useState)(null);
  const [popoverStyles, setPopoverStyles] = (0, import_react3.useState)({});
  const popoverRef = (0, import_react3.useRef)(null);
  const tailLength = tailLengths[popoverProps.size || "m"];
  const updatePopoverStyles = (0, import_react3.useCallback)(
    () => updatePositionedElementStyles({
      nodePosition,
      positionedElementRef: popoverRef,
      direction: popoverProps.direction,
      setPositionedElementStyles: setPopoverStyles,
      tailOffset,
      tailLength,
      isPositionFixed: true
    }),
    [nodePosition, popoverRef, setPopoverStyles, popoverProps, tailLength]
  );
  (0, import_react3.useEffect)(() => {
    let scrollPosition = { top: 0, left: 0 };
    const disableScroll = () => {
      scrollPosition = { top: window.scrollY, left: window.scrollX };
      window.addEventListener("scroll", keepScrollPosition, { passive: false });
    };
    const enableScroll = () => {
      window.removeEventListener("scroll", keepScrollPosition);
    };
    const keepScrollPosition = (event) => {
      if (showPopover) {
        window.scrollTo(scrollPosition.left, scrollPosition.top);
        event.preventDefault();
      }
    };
    disableScroll();
    return () => {
      enableScroll();
    };
  }, [showPopover]);
  (0, import_react3.useEffect)(() => {
    const updatePopoverPositionIfShown = () => {
      if (showPopover) {
        updatePopoverStyles();
      }
    };
    updatePopoverPositionIfShown();
    window.addEventListener("resize", updatePopoverPositionIfShown);
    return () => {
      window.removeEventListener("resize", updatePopoverPositionIfShown);
    };
  }, [
    showPopover,
    nodePosition,
    popoverProps.direction,
    tailLength,
    updatePopoverStyles
  ]);
  const handleEvent = (event) => {
    setNodePosition(event.currentTarget);
  };
  const mergeEventHandlers = (existingHandler, newHandler) => (event) => {
    if (existingHandler) existingHandler(event);
    if (newHandler) newHandler(event);
  };
  const clonedChildren = (0, import_react3.isValidElement)(children) && (0, import_react3.cloneElement)(children, {
    onMouseEnter: mergeEventHandlers(
      children.props.onMouseEnter,
      handleEvent
    ),
    onFocus: mergeEventHandlers(children.props.onFocus, handleEvent),
    onBlur: mergeEventHandlers(children.props.onBlur, handleEvent),
    onMouseLeave: mergeEventHandlers(
      children.props.onMouseLeave,
      handleEvent
    )
  });
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(import_jsx_runtime6.Fragment, { children: [
    clonedChildren,
    showPopover && /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(Popover_default, { ...popoverProps, ref: popoverRef, style: popoverStyles })
  ] });
};
var WithPopover_default = WithPopover;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  WithPopover
});
//# sourceMappingURL=index.js.map